<template>
  <div class="plan-page">
    <Input class="info" v-model="search" :placeholder="$t('plan.Collector.search')">
           <Button slot="append" icon="ios-search" @click="handleSearch()"></Button>
           <Button slot="append" icon="refresh" @click="handleReset()"></Button>
        </Input>
    <br>
    <Row>
      <Col span="2" class="plan-title">{{$t('plan.Collector.name')}}</Col>
      <Col span="22">
        <Row class="plan-title-wrapper"><Col span="4">{{$t('plan.Collector.one')}}</Col><Col span="4">{{$t('plan.Collector.two')}}</Col><Col span="4">{{$t('plan.Collector.three')}}</Col><Col span="4">{{$t('plan.Collector.four')}}</Col><Col span="4">{{$t('plan.Collector.fiv')}}</Col><Col span="4">{{$t('plan.Collector.six')}}</Col></Row>
      </Col>
    </Row>
    <Row v-for="(cplan,cindex) in collectorPlanDatas" :key="cplan.name">
      <Col span="2">
        <div class="collector-name">{{cplan.name}}</div>
      </Col>
      <Col span="22">
        <Row>
          <Col v-for="(item, index) in cplan.plans" :key="item.plans.length" class="plan-row" span="4">
            <Badge v-if="item.plans.length > 1" :count="item.plans.length">
              <div class="plan-info" v-if="item.plans.length !== 0" @click="exporePlan(cindex,index)">
                <p>{{$t('plan.Collector.orderNo')}}: {{item.plans[0].orderNo}}</p>
                <p>{{$t('plan.Collector.productNo')}}: {{item.plans[0].productNo}}</p>
                <p>{{$t('plan.Collector.row')}}: {{item.plans[0].row}}</p>
              </div>
            </Badge>
            <span v-else class="plan-info-span">
              <div class="plan-info" v-if="item.plans.length !== 0">
                <p>{{$t('plan.Collector.orderNo')}}: {{item.plans[0].orderNo}}</p>
                <p>{{$t('plan.Collector.productNo')}}: {{item.plans[0].productNo}}</p>
                <p>{{$t('plan.Collector.row')}}: {{item.plans[0].row}}</p>
              </div>
            </span>
            <br>
            <Button v-if="index == 0 && item.plans.length !== 0 && cplan.producting == 0 && permissions === true" type="ghost" @click="production(cindex)">{{$t('plan.Collector.yes')}}</Button>
            <Button v-if="index == 0 && item.plans.length !== 0 && cplan.producting == 0 && permissions !== true" type="ghost" @click="production(cindex)" disabled>{{$t('plan.Collector.yes')}}</Button>
            <Button v-if="index == 0 && item.plans.length !== 0 && cplan.producting == 1 && permissions === true" type="ghost" @click="productionStop(cindex)">{{$t('plan.Collector.no')}}</Button>
            <Button v-if="index == 0 && item.plans.length !== 0 && cplan.producting == 1 && permissions !== true" type="ghost" @click="productionStop(cindex)" disabled>{{$t('plan.Collector.no')}}</Button>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>
<script>
import { Api } from '@/api'

export default {
  name: 'Plan',
  data () {
    return {
      collectorPlanDatas: [],
      search: '',
      list: [],
      permissions: false
    }
  },
  methods: {
    exporePlan (cindex, index) {
      let content = '<div class="plan-dialog">'
      let p = this.collectorPlanDatas[cindex].plans[index].plans
      for (let i = 0; i < p.length; i++) {
        content += '<div>'
        content += '<p>' + this.$t('plan.Collector.orderNo') + p[i].orderNo + '</p>'
        content += '<p>' + this.$t('plan.Collector.productNo') + p[i].productNo + '</p>'
        content += '<p>' + this.$t('plan.Collector.row') + p[i].row + '</p>'
        content += '</div>'
      }
      content += '</div>'
      this.$Modal.info({
        title: '',
        content: content
      })
      console.log(index)
    },
    production (cindex) {
      Api.collectorPlan.production(this.collectorPlanDatas[cindex].collectorID).then(() => {
        this.collectorPlanDatas[cindex].producting = 1
      })
    },
    productionStop (cindex) {
      if (confirm(this.$t('plan.Collector.delete_message'))) {
        Api.collectorPlan.productionStop(this.collectorPlanDatas[cindex].collectorID).then(() => {
          this.collectorPlanDatas[cindex].producting = 0
          this.collectorPlanDatas[cindex].plans.splice(cindex, 1)
        })
      }
    },
    handleSearch () {
      this.collectorPlanDatas = []
      for (let i = 0; i < this.list.length; i++) {
        let p = this.list[i]
        if (p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          this.collectorPlanDatas.push(p)
        }
      }
    },
    handleReset () {
      this.collectorPlanDatas = this.list
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'production_plan' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.collectorPlan.list().then(res => {
      // let sortBy = function (filed, rev, primer) {
      //   rev = (rev) ? -1 : 1
      //   return function (a, b) {
      //     a = a[filed]
      //     b = b[filed]
      //     if (typeof (primer) !== 'undefined') {
      //       a = primer(a)
      //       b = primer(b)
      //     }
      //     if (a < b) { return rev * -1 }
      //     if (a > b) { return rev * 1 }
      //     return 1
      //   }
      // }
      // res.collectorPlanInfo.sort(sortBy('name', false, parseInt))
      res.collectorPlanInfo.sort(function (a, b) {
        if (a['name'] > b['name']) {
          return 1
        } else {
          return -1
        }
      })
      next(vm => {
        vm.collectorPlanDatas = res.collectorPlanInfo
        vm.list = res.collectorPlanInfo
      })
    })
  }
}
</script>
<style scoped>
.plan-page {
  padding: 10px;
}

.plan-row {
  background: #fff;
  border: 1px solid #999;
  padding: 20px 0 5px 0;
  text-align: center;
  height: 150px;
}
.plan-info {
  margin: 10px 10px;
}
.plan-info p {
  line-height: 20px;
}
.plan-info-span {
  position: relative;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}
.plan-title,.plan-title-wrapper .ivu-col {
  border: 1px solid #999;
  text-align: center;
}
.collector-name {
  border: 1px solid #999;
  text-align: center;
  height: 150px;
  line-height: 100px;
}

</style>
<style>
.plan-dialog {
  width: 100%;
}
.plan-dialog > div {
  display: inline-block;
  width: 33.33%;
}
.plan-page .info {
  width: 33.3%;
}
</style>






// WEBPACK FOOTER //
// Collector.vue?b24f9682